module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "pay-rate-editor"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered config-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v("Salaried")]), _vm._v(" "), _c('td', [_c('draggable', {
    staticClass: "pay-type-container",
    attrs: {
      "list": _vm.salary,
      "options": _vm.options
    }
  }, _vm._l((_vm.salary), function(name) {
    return _c('div', {
      staticClass: "pay-dragger"
    }, [_vm._v(_vm._s(name))])
  }))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Hourly")]), _vm._v(" "), _c('td', [_c('draggable', {
    staticClass: "pay-type-container",
    attrs: {
      "list": _vm.hourly,
      "options": _vm.options
    },
    on: {
      "add": _vm.update,
      "remove": _vm.update
    }
  }, _vm._l((_vm.hourly), function(name) {
    return _c('div', {
      staticClass: "pay-dragger"
    }, [_vm._v(_vm._s(name))])
  }))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Pay Type")]), _vm._v(" "), _c('th', [_vm._v("Schoox Job Names")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f30fc6e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PayTypeEditor.vue
// module id = 412
// module chunks = 2